import { render } from "./NoItems.vue?vue&type=template&id=51ff4e5a"
import script from "./NoItems.vue?vue&type=script&lang=js"
export * from "./NoItems.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__